import {
  createMessageHistoryController,
  type MessageHistoryNavigation,
} from './createMessageHistoryController';
import {
  getScopedMessageHistorySessionId,
  loadPersistedMessageHistorySession,
  persistMessageHistorySession,
  touchPersistedMessageHistorySession,
} from './messageHistoryPersistence';

const messageHistoryControllers = new Map<string, MessageHistoryNavigation>();
const messageHistoryRefCounts = new Map<string, number>();

export function acquireMessageHistorySession({
  sessionId,
}: {
  sessionId: string;
}): MessageHistoryNavigation {
  const scopedSessionId = getScopedMessageHistorySessionId({ sessionId });
  const nextRefCount = (messageHistoryRefCounts.get(scopedSessionId) ?? 0) + 1;
  messageHistoryRefCounts.set(scopedSessionId, nextRefCount);

  let controller = messageHistoryControllers.get(scopedSessionId);
  if (!controller) {
    const initialEntries = loadPersistedMessageHistorySession({ sessionId });
    controller = createMessageHistoryController({
      initialEntries,
      onHistoryChanged: (entries) => {
        persistMessageHistorySession({ sessionId, entries });
      },
    });
    messageHistoryControllers.set(scopedSessionId, controller);
  }

  touchPersistedMessageHistorySession({ sessionId });

  return controller;
}

export function releaseMessageHistorySession({
  sessionId,
}: {
  sessionId: string;
}): void {
  const scopedSessionId = getScopedMessageHistorySessionId({ sessionId });
  const currentRefCount = messageHistoryRefCounts.get(scopedSessionId) ?? 0;
  if (currentRefCount <= 1) {
    messageHistoryRefCounts.delete(scopedSessionId);
    messageHistoryControllers.delete(scopedSessionId);
    return;
  }

  messageHistoryRefCounts.set(scopedSessionId, currentRefCount - 1);
}

export function resetMessageHistorySessionsForTest(): void {
  messageHistoryControllers.clear();
  messageHistoryRefCounts.clear();
}
